import React from "react";
import { Card, Row, Col, Icon } from "antd";
import { CaseService } from "../../services";

const overdueCibilAccountDetailsObj = {
    account_type: { label: "Account Type", value: "" },
    high_credit_amount: { label: "Loan Amount", value: "₹" },
    opened_on: { label: "Issued On", value: "" },
    overdue_amount: { label: "Overdue Amount", value: "₹" },
    days_past_due: { label: "Overdue Since", value: " days" },
    cibil_support_document: { label: "Clearance Proof", value: "" }
};

class OverdueAccountDetails extends React.Component {
    state = {
        overdueCibilAccountDetails: []
    };
    
    componentDidMount() {
        CaseService.OverdueCibilAccountDetails(this.props.caseId)
            .then(res => {
                this.setState({ overdueCibilAccountDetails: res.data });
            })
            .catch(err => {
                console.log("inside catch err", err);
            });
    }
    render() {
        const { overdueCibilAccountDetails } = this.state;
        return (
            overdueCibilAccountDetails?.length>0 && <Card title="Overdue and CC/OD Account Details" className="padless-card small-card-title">
            <div className="scrollable-content">
                <Row gutter={16}>
                    {overdueCibilAccountDetails.map((applicant, index) => (
                        <Col span={24} key={index} className="applicant-section">
                            <Row 
                                gutter={16}
                                className="p-10 d-flex align-items-center"
                            >
                               <h4> {`Applicant: ${applicant.applicant_name} (ID: ${applicant.applicant_id})`} </h4>
                            </Row>
                            {applicant.accounts.length > 0 && applicant.accounts.map((item, key) => {
                                const sortedEntries = Object.entries(item).sort(([a], [b]) => {
                                    if (a === "account_type") return -1;
                                    if (b === "account_type") return 1;
                                    return 0;
                                });

                                return (
                                    <Row
                                        gutter={16}
                                        className="p-10 d-flex align-items-center"
                                        key={key}
                                    >
                                        {sortedEntries?.filter(([el]) => overdueCibilAccountDetailsObj[el])
                                            .map(([el, k]) => (
                                                el === "cibil_support_document" ? (
                                                    <Col
                                                        span={4}
                                                        className={`mt-10 ${!k && "disabled-link"}`}
                                                        key={k}
                                                    >
                                                        <a href={k} target="_blank" rel="noopener noreferrer">
                                                            <div>
                                                                <Icon type="download" />
                                                                {overdueCibilAccountDetailsObj[el]?.label}
                                                            </div>
                                                        </a>
                                                    </Col>
                                                ) : (
                                                    <Col span={4} className="mt-10" key={k}>
                                                        <h4>{overdueCibilAccountDetailsObj[el]?.label}</h4>
                                                        <p>
                                                            {el === "days_past_due" 
                                                                ? k + overdueCibilAccountDetailsObj[el]?.value 
                                                                : overdueCibilAccountDetailsObj[el]?.value + k}
                                                        </p>
                                                    </Col>
                                                )
                                            ))}
                                    </Row>
                                );
                            })}
                            <div className="p-10 d-flex flex-column">
                                <h3>CC/OD Account Declaration/Proof</h3>
                                <p>
                                    Please review the salesperson consent or the clearance proof
                                    provided
                                </p>
                                {applicant.cc_od_consent_details?.type === "CONSENT" ? (
                                    <Col
                                        span={12}
                                        className="mt-10 d-flex align-items-center justify-content-space-between"
                                    >
                                        <h4>Verified by Salesperson Emp ID</h4>
                                        <div className="d-flex flex-column align-items-center">
                                            <h5>Salesperson Employee ID</h5>
                                            <p>
                                                {applicant.cc_od_consent_details?.consent_employee_id}
                                            </p>
                                        </div>
                                    </Col>
                                ) : (
                                    <Col
                                        span={12}
                                        className="mt-10 d-flex align-items-center justify-content-space-between"
                                    >
                                        <h4>CC/OD Account Statement 6 Months</h4>
                                        <a
                                            href={applicant.cc_od_consent_details?.cibil_support_document}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={`mt-10 ${!applicant.cc_od_consent_details?.cibil_support_document && "disabled-link"}`}
                                        >
                                            <Icon type="download" />
                                            Clearance Proof
                                        </a>
                                    </Col>
                                )}
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        </Card>
        );
    }
}

export default OverdueAccountDetails;
